import type React from 'react';

interface ListProps {
	data: React.ReactNode[];
}

export const List = ({ data }: ListProps) =>
	data.reduce((prev, curr) => (prev ? [prev, ', ', curr] : curr), null);
